import { CMaterialType } from '@chamn/model';
import { snippets } from './snippets';

export const InputMeta: CMaterialType = {
  componentName: 'Input',
  title: '输入框',
  props: [],
  npm: {
    name: 'Input',
    package: __PACKAGE_NAME__ || '',
    version: __PACKAGE_VERSION__,
    destructuring: true,
    exportName: 'Input',
  },
  snippets: snippets,
};

export default [InputMeta];

export type A = string;
